// Copyright 2026, University of Maryland, All Rights Reserved
/**
 * Shared types/helpers for resource-ID conflicts returned by the promote and
 * instantiate endpoints (HTTP 409 with `detail.conflicts`).
 */

/** A target ID the backend rejected because it already exists at the destination. */
export interface ResourceConflict {
  field: 'agentId' | 'kb'
  source: string
  message: string
}

/** Pull structured resource conflicts out of a 409 response, if present. */
export const extractResourceConflicts = (err: unknown): ResourceConflict[] | null => {
  const detail = (err as { response?: { data?: { detail?: unknown } } })
    ?.response?.data?.detail
  if (detail && typeof detail === 'object' && Array.isArray((detail as { conflicts?: unknown }).conflicts)) {
    return (detail as { conflicts: ResourceConflict[] }).conflicts
  }
  return null
}

/** Index conflicts of one field by their source key (for IdMapSection error maps). */
export const conflictsBySource = (
  conflicts: ResourceConflict[],
  field: ResourceConflict['field'],
): Record<string, string> =>
  Object.fromEntries(
    conflicts.filter(c => c.field === field).map(c => [c.source, c.message]),
  )
